import { useState } from "react";
import { Spinner } from "@/components/kit";
import { useAdminQuery } from "@/hooks/queries";
import { fmtDateTime, periodLabel, rupees } from "@/lib/toto";
import { AdminHeader, AdminTable, StatCard } from "@/pages/admin/AdminLayout";

const fmtCell = (k, v) => {
  if (v == null || v === "") return "—";
  if (/paise/i.test(k) && typeof v === "number") return rupees(v);
  if (/(date|At)$/i.test(k) && typeof v === "string") return fmtDateTime(v);
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
};

function Records() {
  const q = useAdminQuery("/admin/subscription-records");
  if (q.isLoading) return <Spinner />;
  if (q.error) return <p className="text-[#DC2626]">{q.error.message}</p>;
  const rows = Array.isArray(q.data) ? q.data : q.data?.items ?? [];
  const keys = rows[0] ? Object.keys(rows[0]).filter((k) => k !== "id" && k !== "_id").slice(0, 9) : [];
  return <AdminTable testid="admin-subscription-records" rows={rows} cols={keys.map((k) => ({ label: k, render: (r) => fmtCell(k, r[k]) }))} empty="No subscription records yet." />;
}

export default function AdminSubscriptions() {
  const [tab, setTab] = useState("payments");
  const q = useAdminQuery("/admin/subscriptions");
  const settings = useAdminQuery("/admin/settings").data;
  const d = q.data;
  return (
    <>
      <AdminHeader title="Subscriptions" sub="Razorpay payments and subscription records." />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-6">
        <StatCard label="Paid orders" value={d?.total} testid="subs-total" />
        <StatCard label="Revenue" value={d ? `₹${Number(d.revenueRupees ?? 0).toLocaleString("en-IN")}` : null} accent="#059669" testid="subs-revenue" />
        <StatCard label="Current plan price" value={settings ? `${rupees(settings.premiumPricePaise)} / ${periodLabel(settings.premiumDurationDays)}` : null} accent="#7C3AED" testid="subs-plan-price" />
      </div>
      <div className="inline-grid grid-cols-2 p-1 rounded-[14px] bg-[#EEF2F9] mb-4">
        {[["payments", "Payments"], ["records", "Subscription records"]].map(([k, l]) => <button key={k} onClick={() => setTab(k)} className={`h-10 px-4 rounded-[11px] text-[14px] font-semibold ${tab === k ? "bg-white text-[#0000EC] shadow-sm" : "text-[#475569]"}`} data-testid={`subs-tab-${k}`}>{l}</button>)}
      </div>
      {tab === "records" ? <Records /> : q.isLoading ? <Spinner /> : (
        <AdminTable testid="admin-subscriptions-table" rows={(d?.items ?? []).map((r) => ({ ...r, id: r.paymentId || r.orderId }))} cols={[
          { label: "User", render: (r) => <span><b>{r.userName}</b><br /><span className="text-[#64748B]">{r.userEmail}</span></span> },
          { label: "Amount", render: (r) => rupees(r.amountPaise) }, { label: "Order", k: "orderId" }, { label: "Payment", k: "paymentId" }, { label: "Date", render: (r) => fmtDateTime(r.date) },
        ]} empty="No payments yet." />
      )}
    </>
  );
}
